var React = require('react');

function Heart (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M21.438,3.938h-.059a6.761,6.761,0,0,0-5.645,3.09,6.761,6.761,0,0,0-5.645-3.09H10.03a6.718,6.718,0,0,0-6.655,6.714,14.463,14.463,0,0,0,2.84,7.885A49.773,49.773,0,0,0,15.734,27.7a49.773,49.773,0,0,0,9.519-9.168,14.463,14.463,0,0,0,2.84-7.885A6.718,6.718,0,0,0,21.438,3.938Z","transform":"translate(-3.375 -3.938)","key":1})]);
}

Heart.defaultProps = {"viewBox":"0 0 24.718 23.767"};

module.exports = Heart;

Heart.default = Heart;
